import { Box, Button, Divider, FormControl, FormLabel, Heading, Icon, IconButton, Input, Stack, useBoolean, VStack } from "@chakra-ui/react";
import { DeepErrorBox } from "components/misc";


import { TCoordinate } from "@api/api.int";
import { Place, SearchForTextResult, SearchPlaceIndexForPositionCommand, SearchPlaceIndexForTextCommand } from "@aws-sdk/client-location";
import { ILocation, useVVStore } from "components/store";
import { useDebounce } from "components/utils";
import { VizvCard, VizvCardAction, VizvCardAction2, VizvCardContent } from "components/vizvComponents";
import { MapTools } from "features/map/MapTools";
import { HUNGARY_CENTER } from "features/map/MyMap";
import { NavMainLink } from "features/NavMain";
import { useEffect, useState } from "react";
import { MdArrowDownward, MdEdit, MdLocationCity, MdLocationSearching } from "react-icons/md";



export interface AffairLocationProps {
	onCancel: () => void;
	onSelect2: (place: Place, titlePublic: string) => void;
	newItem: Omit<ILocation, 'geoLat' | 'geoLng'>;
	headStrip?: React.ReactNode;
}


export function AffairLocation({ onCancel, newItem, headStrip, onSelect2 }: AffairLocationProps) {

	const store = useVVStore();


	const [stage, setStage] = useState<'ADDRESS' | 'ADDRESS_CONFIRM'>('ADDRESS');
	useEffect(() => {
		//store.setMapMode(stage === 'ADDRESS' || stage === 'ADDRESS_CONFIRM' ? 'SELECT' : 'SHOW_SELECT');
		store.setMapMode('SELECT'); // kell ez egyáltalán???
	}, [store.mapMode, stage]);

	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const [citySearch, setCitySearch] = useState('');
	const debouncedCitySearch = useDebounce(citySearch, 1000);
	const [biasCity, setBiasCity] = useState<Place | undefined>();
	const [place, setPlace] = useState<Place | undefined>();

	const [search, setSearch] = useState('');
	const [isMapForce, setIsMapForce] = useState(false);
	const debouncedSearch = useDebounce(search, 1000);

	// ============================== TITLE ==================================
	const [titleExact, setTitleExact] = useState('');
	const [titlePublic, setTitlePublic] = useState('');
	const [titleSuggs, setTitleSuggs] = useState<string[]>([]);
	useEffect(() => {
		console.log('PLACE', place);
		setTitleExact('');
		setTitlePublic('');
		setTitleSuggs([]);
		if (!place)
			return;
		const arr = (place.Label || '').split(',');
		let exact = '';
		let suggs = new Array<string>();
		// ---------------- EXACT -----------------
		if (place.Categories?.find(c => c === 'AddressType') && place.Label && place.Municipality && arr.length >= 2) {
			const address = arr[arr.length - 2].trim();
			console.log('WAY AddressType', address, arr);
			exact = place.Municipality + ', ' + address;
			suggs.push(exact);
			const street = address.replace(/[0-9]/g, "").replace(/[ \-]+$/g, '');
			suggs.push(place.Municipality + ', ' + street);
			if (place.SubMunicipality)
				suggs.push(place.Municipality + ', ' + place.SubMunicipality);
			suggs.push(place.Municipality)
		} else if (place.Categories?.find(c => c === 'StreetType') && place.Municipality && arr.length >= 2) {
			console.log('WAY StreetType');
			exact = place.Municipality + ', ' + arr[arr.length - 2].trim();
			suggs.push(exact);
			if (place.SubMunicipality)
				suggs.push(place.Municipality + ', ' + place.SubMunicipality);

		} else if (place.Municipality) {
			console.log('WAY municipality');
			exact = place.Municipality;
			suggs.push(place.Municipality);
			if (place.SubMunicipality)
				suggs.push(place.Municipality + ', ' + place.SubMunicipality);
		} else {
			exact = 'Furcsa egy cím...';
		}


		setTitleExact(exact);
		setTitleSuggs(suggs);

	}, [place]
	)

	const editTitle = (text : string) => {
		if (!place)
			return;
		const titlePublic = window.prompt('Hogy mutassuk másoknak a címet?', text );
		if (!titlePublic)
			return;
		onSelect2(place, titlePublic);
	}
	// ============================== CLICKED ON THE MAP ==================================
	const [lastLngLat, setLastLngLat] = useState('');
	useEffect(() => {
		if (!store.createLngLat)
			return;
		let x = '' + store.createLngLat[0] + ';' + store.createLngLat[1];
		if (x === lastLngLat)
			return;

		setLastLngLat(x);
		setPlace(undefined);
		setSuggestions([]);
		setCitySuggestions([]);
		//setBiasCity(undefined);
		setSearch('');
		setCitySearch('');

		(async () => {
			setError('');
			setIsLoading.on();
			try {

				let params = {
					IndexName: 'explore.place',
					Position: store.createLngLat,
					Language: "hu",
					MaxResults: 1,
				};

				const searchCommand = new SearchPlaceIndexForPositionCommand(params);
				const data = await store.locationClient.send(searchCommand);
				console.log('------------------ search place --------------------')
				if (data.Results && data.Results.length > 0
					&& data.Results[0].Place

				) {
					setPlace(data.Results[0].Place)
				};

			} catch (error) {
				console.error(error);
				setError('' + error);
			} finally {
				setIsLoading.off();
			}
		})();


	}, [store.createLngLat, lastLngLat]);


	// ============================== TYPED SEARCH CITY ==================================
	const [citySuggestions, setCitySuggestions] = useState<SearchForTextResult[]>([]);

	useEffect(() => {
		setPlace(undefined);
		setCitySuggestions([]);
		setSuggestions([]);
		setSearch('');
		if (!debouncedCitySearch)
			return;
		let isZip = false;
		if (['1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(debouncedCitySearch[0]) !== -1) {
			isZip = true;
			if (debouncedCitySearch.length !== 4)
				return;
		} else {
			if (debouncedCitySearch.length < 3)
				return;
		}
		(async () => {
			setError('');
			setIsLoading.on();
			try {
				const data = await store.locationClient.send(new SearchPlaceIndexForTextCommand({
					IndexName: 'explore.place',
					Text: debouncedCitySearch,
					//BiasPosition: store.createLngLat || HUNGARY_CENTER,
					FilterCountries: ['HUN'],
					Language: 'hu',
					MaxResults: 4,
					FilterCategories: isZip ? ['PostalCodeType'] : ['MunicipalityType'],

				}));
				const arr: SearchForTextResult[] = [];
				const already = new Set<string>();
				for (let res of data.Results || []) {
					if (res.Place?.Municipality && !already.has(res.Place?.Municipality)) {
						arr.push(res);
						already.add(res.Place.Municipality);
					}
				}
				setCitySuggestions(arr);
			} catch (error) {
				console.error(error);
				setError('' + error);
			} finally {
				setIsLoading.off();
			}
		})();
	}, [debouncedCitySearch]);

	const onCitySuggestionSelect = (sug: SearchForTextResult) => {
		if (!sug.Place || !sug.Place.Geometry || !sug.Place.Geometry.Point) {
			alert('mivan?');
			return;
		}
		setBiasCity(sug.Place);
		setCitySuggestions([]);
		setCitySearch('');
		setSuggestions([]);
		setSearch('');

		// mutatom a térképen
		if (sug.Place && sug.Place.Geometry && sug.Place.Geometry.Point)
			store.setSuggestionList([{
				...newItem,
				/*geoGroupXXX: 'Location',
				kind: 'NewInCity',
				title: 'Város'*/
				geoLng: sug.Place.Geometry.Point[0],
				geoLat: sug.Place.Geometry.Point[1],
			} as ILocation])
	}




	// ============================== TYPED SEARCH ADDRESS ==================================
	const [suggestions, setSuggestions] = useState<SearchForTextResult[]>([]);


	useEffect(() => {
		if (!debouncedSearch)
			return;
		setPlace(undefined);
		if (!debouncedSearch || debouncedSearch.length < 3)
			return;
		const combinedText = biasCity?.PostalCode + ' ' + biasCity?.Municipality + ' ' + debouncedSearch;
		(async () => {
			setError('');
			setIsLoading.on();
			try {
				const data = await store.locationClient.send(new SearchPlaceIndexForTextCommand({
					IndexName: 'explore.place',
					Text: combinedText,
					BiasPosition: biasCity?.Geometry?.Point || HUNGARY_CENTER,
					FilterCountries: ['HUN'],
					Language: 'hu',
					MaxResults: 4
				}))
				let res0 = (data.Results || []).filter(sug => sug.Place);
				let res = res0.filter(sug => sug.Place!.Categories?.indexOf('AddressType') !== -1);
				if (res.length === 0)
					res = res0.filter(sug => sug.Place!.Categories?.indexOf('StreetType') !== -1);
				if (res.length === 0)
					res = res0;

				setSuggestions(res);
			} catch (error) {
				console.error(error);
				setError('' + error);
			} finally {
				setIsLoading.off();
			}
		})();
	}, [debouncedSearch, biasCity]);

	const onSuggestionHover = (sug: SearchForTextResult) => {
		let place = sug.Place;
		if (place && place.Geometry && place.Geometry.Point)
			store.setSuggestionList([{
				...newItem,
				/*geoGroupXXX: 'Location',
				/*kind: 'New',
				title: 'Jelentem'*/
				geoLng: place.Geometry.Point[0],
				geoLat: place.Geometry.Point[1],
			} as ILocation])
	}

	const onSuggestionSelect = (sug: SearchForTextResult) => {
		if (!sug.Place || !sug.Place.Geometry || !sug.Place.Geometry.Point) {
			alert('mivan?');
			return;
		}
		setPlace(sug.Place);
		setSuggestions([]);
		setSearch('');
	}

	// ============================== MY LOCATOIN ==================================

	const [myLocation, setMyLocation] = useState<TCoordinate | 'notchecked' | 'error'>('notchecked');
	const myLocationClick = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(position => {
				const longLat: TCoordinate = [position.coords.longitude, position.coords.latitude];
				setMyLocation(longLat);
				findMyLocationAsPlace(longLat);
			});
		} else {
			setMyLocation('error');
		}
	}

	const onMyLocationClick = (longLat: TCoordinate) => {
		setMyLocation(longLat);
		findMyLocationAsPlace(longLat);
	}

	const findMyLocationAsPlace = async (longLat: TCoordinate) => {
		setError('');
		setIsLoading.on();
		try {
			const data = await store.locationClient.send(new SearchPlaceIndexForPositionCommand({
				IndexName: 'explore.place',
				Position: longLat,
				//FilterCountries: ['HUN'],
				Language: 'hu',
				MaxResults: 1
			}))
			//setSuggestions(data.Results || []);
			// mutatom a térképen
			if (data.Results && data.Results.length > 0 && data.Results[0].Place) {
				const place = data.Results[0].Place;
				setPlace(place);
			}

		} catch (error) {
			console.error(error);
			setError('' + error);
		} finally {
			setIsLoading.off();
		}
	}



	// ============================== TÉRKÉPEN IS MUTATOM ==================================
	useEffect(() => {
		if (place && place.Geometry && place.Geometry.Point) {
			const loc = {
				...newItem,
				/*geoGroupXXX: 'Location',
				kind: 'New',
				title: 'Jelentem'*/
				geoLng: place.Geometry.Point[0],
				geoLat: place.Geometry.Point[1],
			} as ILocation;
			store.setSuggestionList([loc]);
		}
		if (place && stage === 'ADDRESS') {
			setStage('ADDRESS_CONFIRM');
		}
		return () => {
			store.setSuggestionList([]);
		}
	}, [place, stage])

	const backFromAddressConfirm = () => {
		setPlace(undefined);
		setStage('ADDRESS');
		store.setSuggestionList([]);
	}

	const onBack = () => {
		if (stage === 'ADDRESS') {
			if (biasCity) {
				setBiasCity(undefined);

			} else {
				onCancel();
			}
		} else {
			backFromAddressConfirm();
		}
	}


	return <VizvCard isTool isClosable onBack={onBack}>
		<DeepErrorBox error={error} isLoading={isLoading} />
		{headStrip}
		{stage === 'ADDRESS' && <Box p={2}>


			{!biasCity
				? <>
					<Box py={5} display='flex' flexDir='column' alignItems='center'>
						<Button onClick={myLocationClick} colorScheme='gray' size='sm' fontWeight='normal' ><Icon as={MdLocationSearching} />&nbsp;Jelenlegi tartózkodási helyem megadása</Button>
					</Box>
					<Divider />
					<Box p={1}>
						<FormControl>
							<FormLabel>Keress településre:</FormLabel>
							<Input placeholder='Irányítószám vagy város...' value={citySearch} onChange={e => setCitySearch(e.currentTarget.value)} />
						</FormControl>
						{citySuggestions.length > 0 &&
							<Stack mt={2} gap={2}>
								{citySuggestions.map((sug, sux) => <VizvCardAction key={sux} protLev='any'
									onClick={() => onCitySuggestionSelect(sug)}
								>
									{(sug.Place?.PostalCode ? sug.Place?.PostalCode + ', ' : '') + (sug.Place?.Municipality || '?')}
								</VizvCardAction>)}
							</Stack>}



					</Box>
					<Divider />
					<Box>Vagy keress a térképen:</Box>
					<Box display='flex' justifyContent='center'>
						<MapTools search={false}
							onClick={() => setStage('ADDRESS_CONFIRM')}
							onMyLocationClick={longLat => onMyLocationClick(longLat)}
						/>
					</Box>

				</>
				: <>
					<Box py={2} display='flex' flexDir='column' alignItems='center'>
						<Button colorScheme='secondary' leftIcon={<MdLocationCity />}  >{biasCity.Label || '??'}</Button>
					</Box>
					<FormLabel>Keresés</FormLabel>
					<Box>
						<fieldset disabled={false && isLoading}>
							<Input placeholder='Utca, házszám...' value={search} onChange={e => setSearch(e.currentTarget.value)} />
						</fieldset>

						{suggestions.length > 0 &&
							<Stack p={2} pb={4} gap={2} >
								{suggestions.map((sug, sux) => <NavMainLink key={sux}
									onClick={() => onSuggestionSelect(sug)}
									onMouseEnter={() => onSuggestionHover(sug)}
								>
									{sug.Place?.Label || '?'}
								</NavMainLink>)}
							</Stack>}
					</Box>
					<Box display='flex' justifyContent='center' alignItems='center' py={1} fontSize='sm'
					//color='InactiveCaptionText'
					>
						<MdArrowDownward />
						<Box as='span'>Vagy a térképre kattintva pontosíthatsz</Box>
						<MdArrowDownward />
					</Box>
				</>
			}
		</Box>}

		{stage === 'ADDRESS_CONFIRM' && <>
			{place
				? <>
					{/*
					<VizvCardContent>
						<Heading size='sm' fontWeight='300' >Ezt a címet jelölted meg:</Heading>
					</VizvCardContent>

					<Box display='flex' flexDir='row' alignItems='flex-start' justifyContent='space-between' gap={0} pl={1}>
						<Box
							onClick={() => onSelect(place)}
							flex={1}
							fontSize='md' lineHeight='1.4rem'
							whiteSpace='wrap' fontWeight='500'>
							{place?.Label}
						</Box>
					</Box>*/}

					<VizvCardContent>
						<Heading size='sm' fontWeight='300' >Mennyire pontosan mutassuk a címet?</Heading>
					</VizvCardContent>

					<VStack>
						{titleSuggs.map((sugg, ix) => 
							
							<VizvCardAction2
								onClick={() => onSelect2(place, sugg)}
							flex={1}
							fontSize='md' lineHeight='1.4rem'
							whiteSpace='wrap' fontWeight='500'
								icon={<IconButton aria-label="Szerkeszt" icon={<MdEdit />} 	onClick={() => editTitle(sugg)} />}
							>
							{sugg}
						</VizvCardAction2>)}
						{/*<VizvCardAction 
							//onClick={() => onSelect(place)}
							flex={1}
							fontSize='md' lineHeight='1.4rem'
							whiteSpace='wrap' fontWeight='500'
							icon={MdEdit}
							>
							Beírom én
						</VizvCardAction>*/}
					</VStack>

				</>
				: <Box display='flex' justifyContent='center'>
					<MapTools search={false}
						onMyLocationClick={longLat => onMyLocationClick(longLat)}
					/>
				</Box>}

			<Box display='flex' justifyContent='center' alignItems='center' py={1} fontSize='sm'
			//color='InactiveCaptionText'
			>
				<MdArrowDownward />
				<Box as='span'>A térképre kattintva még pontosíthatsz</Box>
				<MdArrowDownward />
			</Box>

		</>}


	</VizvCard>
}